export default {
    site_name: "mw join"
}